<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SNAP_GOODS"
            @click.stop="handleAdd()"
          >新增
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SNAP_GOODS"
            @click.stop="deleteSnapGoods"
          >删除
          </el-button>
          <!--<el-button type="danger"-->
          <!--icon="el-icon-check"-->
          <!--size="small"-->
          <!--plain-->
          <!--v-if="permission.JOINS_SALES_BRAND_DEL_TRUE"-->
          <!--@click.stop="updateSnapGoodsStatus1('down')">下架-->
          <!--</el-button>-->
          <!--<el-button type="danger"-->
          <!--icon="el-icon-check"-->
          <!--size="small"-->
          <!--plain-->
          <!--v-if="permission.JOINS_SALES_BRAND_DEL_TRUE"-->
          <!--@click.stop="updateSnapGoodsStatus1('up')">上架-->
          <!--</el-button>-->
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="handleDetail(scope.row,scope.index)"
          >查看
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status=='PUTAWAY'"
            @click.stop="updateSnapGoodsStatus(scope.row.id,'down')"
          >下架
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status=='UNDERCARIAGE'"
            @click.stop="updateSnapGoodsStatus(scope.row.id,'up')"
          >上架
          </el-button>
        </template>
        <template
          slot-scope="scope"
          slot="brandNameForm"
        >
          <el-select
            v-model="brand"
            placeholder="请选择品牌"
            required
            value-key="id"
          >
            <el-option
              v-for="brand in brands"
              :key="brand.id"
              :label="brand.name"
              :value="brand"
            ></el-option>
          </el-select>
        </template>

        <template
          slot-scope="scope"
          slot="agentIdForm"
        >
          <el-select
            v-model="department"
            placeholder="请选择代理商"
            required
            value-key="id"
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.company"
              :value="department"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="describeImgsForm"
        >
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList"
            :http-request="fnUploadDescribeImgs"
            :show-file-list="false"
          >
            <div
              v-if="'' != describeImgs"
              class="el-upload el-upload--picture-img"
            >
              <div
                :key="describeImg.id"
                v-for="describeImg of describeImgs"
              >
                <img
                  :src="describeImg"
                  style="width: 200px;"
                />
                <a
                  style="margin-left: 20px"
                  @click.stop="deleteDes(describeImg)"
                >删除</a>
              </div>
            </div>
            <div
              v-else
              class="el-upload el-upload--car-two"
            >
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template
          slot-scope="scope"
          slot="wheelsImgsForm"
        >
          <el-upload
            :multiple="true"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList1"
            :http-request="fnUploadWheelsImgs"
            :show-file-list="false"
          >
            <div
              v-if="'' != wheelsImgs"
              class="el-upload el-upload--picture-img"
            >
              <div
                :key="wheelsImg.id"
                v-for="wheelsImg of wheelsImgs"
              >
                <img
                  :src="wheelsImg"
                  style="width: 200px;"
                />
                <a
                  style="margin-left: 20px"
                  @click.stop="deletePic(wheelsImg)"
                >删除</a>
              </div>
            </div>
            <div
              v-else
              class="el-upload el-upload--car-two"
            >
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template
          slot-scope="scope"
          slot="status1"
        >
          <el-tag
            v-for="obj of snapGoodsStatuses"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >
            {{obj.label}}
          </el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="goodsPricesForm"
        >
          <div>
            <el-table
              :data="goodsPrices"
              border
            >
              <el-table-column
                prop="price"
                align="center"
                label="价格"
              >
                <template slot-scope="scope">
                  <el-input
                    type="number"
                    name="price"
                    v-model="scope.row.price"
                    :value="scope.row.price"
                    placeholder="请输入价格"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="inventory"
                align="center"
                label="库存"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="inventory"
                    v-model="scope.row.inventory"
                    :value="scope.row.inventory"
                    placeholder="请输入库存"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="clientType"
                align="center"
                label="用户类型"
                sortable
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.clientType"
                    placeholder="请选择用户类型"
                    required
                    value-key="value"
                  >
                    <el-option
                      v-for="clientType in clientTypes"
                      :key="clientType.value"
                      :label="clientType.label"
                      :value="clientType.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div>
          </div>
        </template>
      </avue-crud>

    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { snapGoodsOption } from "@/const/salesCloud/snapGoodsOption";
import {
  findSnapGoods,
  addSnapGoods,
  updateSnapGoods,
  updateSnapGoodsStatus,
  deleteSnapGoods
} from "@/api/salesCloud/snapGoods";
import {
  findBrand,
  chooseSecondClassify,
  findClassify,
  findAllSuperiorDepartment
} from "@/api/sales/goodsQr";
import { findByLabel, formatterTime } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "snapGoods",
  data() {
    return {
      tableOption: snapGoodsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      snapGoodsStatuses: DIC.PRODUCT_STATUS,
      brands: [],
      brand: {},
      departments: [],
      department: {},
      productStatus: "PUTAWAY",
      dispatching: "EXPRESS",
      describeImgs: [],
      wheelsImgs: [],
      fileList: [],
      fileList1: [],
      goodsPrices: [],
      clientTypes: DIC.CLIENT_TYPE
    };
  },
  created() {
    findBrand().then(res => {
      let data = JSON.parse(res.data);
      this.brands = data.rows;
      console.log(this);
    });

    findAllSuperiorDepartment().then(res => {
      let data = JSON.parse(res.data);
      this.departments = data;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    deleteDes(describeImg) {
      let index = this.describeImgs.indexOf(describeImg);
      if (index > -1) {
        this.describeImgs.splice(index, 1);
      }
    },
    deletePic(wheelsImg) {
      let index = this.wheelsImgs.indexOf(wheelsImg);
      if (index > -1) {
        this.wheelsImgs.splice(index, 1);
      }
    },
    clean() {
      this.brand = {};
      this.department = {};
      this.describeImgs = [];
      this.wheelsImgs = [];
      this.goodsPrices = [];
    },
    handleAddRows() {
      let list = {
        price: 0,
        discount: "",
        clientType: ""
      };
      this.goodsPrices.unshift(list);
    },
    handleSteppingDelete(index, row) {
      this.goodsPrices.splice(index, 1);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findSnapGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findSnapGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findSnapGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findSnapGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.prices = [];
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.goodsPrices = row.goodsPrices;
      this.describeImgs = row.describe;
      this.wheelsImgs = row.wheels;
      this.brand = { id: row.brandId };
      console.log(row);
      this.department = { id: row.agentId };
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findSnapGoods(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.brandId = this.brand.id;
      row.agentId = this.department.id;
      row.describe = this.describeImgs;
      row.wheels = this.wheelsImgs;
      row.goodsPrices = this.goodsPrices;
      console.log("data:" + JSON.stringify(row));
      addSnapGoods(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.brandId = this.brand.id;
      row.agentId = this.department.id;
      row.describe = this.describeImgs;
      row.wheels = this.wheelsImgs;
      row.goodsPrices = this.goodsPrices;
      updateSnapGoods(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    handleDetail(row, index) {
      this.goodsPrices = row.goodsPrices;
      this.describeImgs = row.describe;
      this.wheelsImgs = row.wheels;
      this.brand = { id: row.brandId };
      this.department = { id: row.agentId };
      this.$refs.crud.rowView(row, index);
    },
    chooseSecondClassify() {
      chooseSecondClassify(this.classify.id).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
    },
    async fnUploadWheelsImgs(option) {
      if (this.wheelsImgs.length >= 5) {
        this.$message({
          showClose: true,
          message: "轮播图不能超过五张",
          type: "error"
        });
        return;
      }
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name);
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.wheelsImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name);
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    updateSnapGoodsStatus1(flag) {
      let val = "是否确认下架?";
      let val1 = "下架成功";
      if (flag == "up") {
        val = "是否确认上架?";
        val1 = "上架成功";
      }
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(val, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          updateSnapGoodsStatus(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: val1,
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },

    updateSnapGoodsStatus(id, flag) {
      let val = "是否确认下架?";
      let val1 = "下架成功";
      if (flag == "up") {
        val = "是否确认上架?";
        val1 = "上架成功";
      }
      this.$confirm(val, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          updateSnapGoodsStatus(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: val1,
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    deleteSnapGoods() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          deleteSnapGoods(ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
